module.exports = __webpack_public_path__ + "static/img/icon-private-sale.00a68833.png";